export const recentUpdate = {
  title: "Recently Updated",
  headers: ["", "ORG. RANK", "ENGAGEMENT RANK"],
  data: [
    {
      name: "Openlane Corp",
      type: 429,
      score: 429,
      new: true
    },
    {
      name: "Goodsilron Inc.",
      type: 877,
      score: 877
    },
    {
      name: "Condax LTD",
      type: 154,
      score: 154
    },
    {
      name: "Y-Corp Systems USA",
      type: 492,
      score: 492
    },
    {
      name: "Nam-zim Contracting",
      type: 540,
      score: 540
    },
    {
      name: "Sumace Industries",
      type: 720,
      score: 720
    }
  ]
};

export const recentEmpty = {
  title: "Recent Records Visited",
  headers: ["", "ORG. RANK", "ENGAGEMENT RANK"],
  data: [],
  type: "file"
};

export const emptyData = {
  title: "Recent Engagement",
  headers: ["", "ORG. RANK", "ENGAGEMENT RANK"],
  data: [],
  type: "data"
};
